export default __webpack_public_path__ + "static/media/5c.8d164366.png";